export const landing = "reservation-landing";
export const attractionsHome = "reservation-attraction-home";
export const attractionsBook = "reservation-attraction-book";
export const attractionsOffersPage = "reservation-attraction-offers";
export const attractionsOfferDetail = "reservation-attraction-offer-detail";
export const attractionsCartPage = "reservation-attraction-cart";
export const attractionsThankyouPage = "reservation-attraction-thankyou";
export type AttractionsPages = (typeof landing) | (typeof attractionsHome) | (typeof attractionsBook) | (typeof attractionsOffersPage) | (typeof attractionsOfferDetail) | (typeof attractionsCartPage) | (typeof attractionsThankyouPage);
export const attractionsPages: string[] = [landing, attractionsHome, attractionsBook, attractionsOffersPage, attractionsOfferDetail, attractionsCartPage, attractionsThankyouPage];

const attractionsRoutes = [
	{
		path: "/:companyId(\\d+)/:systemId(\\d{4,})/landing",
		name: landing,
		component: () => import("@app-views/multi-attraction/landing/landing.vue")
	},
	{
		path: "/:companyId(\\d+)/:systemId(\\d{4,})/multi-attractions",
		name: attractionsHome,
		component: () => import("@app-views/multi-attraction/attractions-home/attraction-home.vue")
	},
	{
		path: "/:companyId(\\d+)/:systemId(\\d{4,})/book-attractions",
		name: attractionsBook,
		component: () => import("@app-views/multi-attraction/book-attractions/book-attractions.vue")
	},
	{
		path: "/:companyId(\\d+)/:systemId(\\d{4,})/book-attractions/offers",
		name: attractionsOffersPage,
		component: () => import("@app-views/multi-attraction/attraction-web-offers/attraction-web-offers.vue")
	},
	{
		path: "/:companyId(\\d+)/:systemId(\\d{4,})/book-attractions/offer-detail",
		name: attractionsOfferDetail,
		component: () => import("@app-views/multi-attraction/attraction-offer-detail/attraction-offer-detail.vue")
	},
	{
		path: "/:companyId(\\d+)/:systemId(\\d{4,})/book-attractions/:reskey/cart",
		name: attractionsCartPage,
		component: () => import("@app-views/multi-attraction/cart/cart.vue")
	},
	{
		path: "/:companyId(\\d+)/:systemId(\\d{4,})/book-attractions/:reskey/thankyou",
		name: attractionsThankyouPage,
		component: () => import("@app-views/multi-attraction/thankyou/thankyou.vue")
	},
];

export default attractionsRoutes;
